import axios from "axios";

export const baseUrl = process.env.REACT_APP_BASE_URL;

export async function AxiosPost(url, dataObject) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`${baseUrl}${url}`, dataObject, config);
    return res.data;
  } catch (err) {
    throw err;
  }
}
export async function AxiosAuthPut(url, dataObject) {
  const auth = JSON.parse(localStorage.getItem("apk"));
  const token = auth.authToken;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.put(`${baseUrl}${url}`, dataObject, config);
    return res.data;
  } catch (err) {
    throw err;
  }
}
export async function AxiosAuthPost(url, dataObject) {
  const auth = JSON.parse(localStorage.getItem("apk"));
  const token = auth.authToken;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.post(`${baseUrl}${url}`, dataObject, config);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function AxiosAuthDel(url) {
  const auth = JSON.parse(localStorage.getItem("apk"));
  const token = auth.authToken;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.post(`${baseUrl}${url}`, config);
    return res.data;
  } catch (err) {
    throw err;
  }
}
export async function AxiosAuthRealDel(url) {
  const auth = JSON.parse(localStorage.getItem("apk"));
  const token = auth.authToken;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.delete(`${baseUrl}${url}`, config);
    return res.data;
  } catch (err) {
    throw err;
  }
}


export async function AxiosGet(url) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${baseUrl}${url}`, config);
    return res.data;
  } catch (err) {
    throw err;
  }
}
export async function AxiosAuthGet(url) {
  const auth = JSON.parse(localStorage.getItem("apk"));
  const token = auth.authToken;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.get(`${baseUrl}${url}`, config);
    return res.data;
  } catch (err) {
    throw err;
  }
}
export async function LoginPost(url, data) {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${data}`,
    },
  };
  // console.log(config);

  const obj = {};

  try {
    const res = await axios.post(`${baseUrl}${url}`, obj, config);
    return res.data;
  } catch (err) {
    throw err;
  }
}



export function imageToBase64(url) {
  return fetch(url)
    .then(response => response.blob()) // Convert image to blob
    .then(blob => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // Get Base64 string
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    });
}


export const uploadFileToCdn = async (file, folderName) => {
  try {
    const formData = new FormData();
    formData.append("folder", folderName);
    formData.append("file", file);

    const response = await axios.post(
      `https://cdn.tehub.ng/upload`,
      formData,
      {
        timeout: 60000,
        // headers: {
        //   "Content-Type": "multipart/form-data",
        // },
      }
    );

    // console.log("Response from uploading file to CDN server:", response.data);

    return response.data.file_link;

  } catch (error) {
    console.error("Exception when uploading file to CDN server:", error.response?.data || error.message);
    return null;
  }
};
